import {createContext, useContext, useState, useMemo, useEffect} from 'react';
import PropTypes from 'prop-types';
import {getEnv} from '../../getEnv';
import {isAuthenticated} from '../../components/auth/sessionStore';
import { gql } from '@apollo/client';

import { useQuery } from "@apollo/client/react";

export const FeatureContext = createContext();

export const FeatureContextProvider = ({children}) => {
  const [featureState, setFeatureState] = useState(null);
  const envFlags = getEnv();
  const [customerFeatureState, setCustomerFeatureState] = useState(null);
  const {data: customerFeatureData} = useQuery(CUSTOMER_FEATURES);
  const {data: featureData} = useQuery(FEATURES);

  //Customer feature state
  useEffect(() => {
    customerFeatureData && setCustomerFeatureState(customerFeatureData?.CustomerFeatures?.result);
  }, [customerFeatureData]);

  //Customer Features reducer
  const enabledCustomerFeatures = customerFeatureState?.reduce((acc, feat) => {
    if (feat.customer_enabled === true) {
        acc.push(feat.feature_code)
    }
    return acc;
  }, [] )

  
  //Feature state (Privoro)
  useEffect(() => {
    featureData && setFeatureState(featureData?.Features?.result);
  }, [featureData]);

  //Features reducer
  const enabledFeatures = featureState?.reduce((acc, feat) => {
    if (feat.enabled === true) {
        acc.push(feat.code)
    }
    return acc;
  }, [] )

  const contextValue = useMemo(() =>({
    feature_whitelist: envFlags?.feature_whitelist === 'true',
    feature_subscriptions: envFlags?.feature_subscriptions === 'true',
    feature_hdm_keys: envFlags?.feature_hdm_keys === 'true',
    feature_rbac: envFlags?.feature_rbac === 'true',
    feature_end_user_messaging: envFlags?.feature_end_user_messaging === 'true',
    feature_phone_bonding: envFlags?.feature_phone_bonding === 'true',
    feature_mdm: enabledFeatures?.includes('MDM'),
    feature_edge_lock: enabledFeatures?.includes('EDGE_LOCK'),
    feature_customer_mdm: enabledFeatures?.includes('MDM') && enabledCustomerFeatures?.includes('MDM'),
    feature_customer_edge_lock: enabledFeatures?.includes('EDGE_LOCK') && enabledCustomerFeatures?.includes('EDGE_LOCK')
  }), [featureState, envFlags])

  return (
    <FeatureContext.Provider value={contextValue}>
      {children}
    </FeatureContext.Provider>
  );
};

const FEATURES = gql`
  query getFeatures {
    Features {
      result {
        code
        enabled
        customer_enabled_default
        customer_allow_turn_off
      }
    }
  }
`;

const CUSTOMER_FEATURES = gql`
  query getCustomerFeatures {
    CustomerFeatures {
      result {
        id
        account_id
        feature_code
        customer_enabled
      }
    }
  }
`;

export default FeatureContextProvider;

export const useFeatureContext = () => {
  return useContext(FeatureContext);
};
